import { ETopic } from '@cian/feedback-form-widget';
import { ITypedReduxAction } from '../../../../packages/redux-utils';

export enum ETopicActionTypes {
  SetTopic = 'topic/set',
}

export interface ISetTopicPayload {
  topic: ETopic | null;
}

export type TTopicSet = ITypedReduxAction<ETopicActionTypes.SetTopic, ISetTopicPayload>;

export type TTopicActions = TTopicSet;
